import { PageContainer } from '../../../shared/PageContainer';
import { OptionProps, useFeedback, ListAndDetail } from "@sis/react-library"
import ListIcon from '@mui/icons-material/List';
import { listAndDetailSamplesRoutes } from "../../ListAndDetailSamplesNavigation";
import { useState } from "react";
import { callMimicApi } from "../../../../utils/commonUtils";
import { CityTownDto } from "../../../sampleData/sampleDataReducer";
import { useSampleData } from "../../../sampleData/useSampleData";
import { ListAndDetailSamplesFiltersPageInfo } from './ListAndDetailSamplesFiltersPageInfo';

export const ListAndDetailSamplesFiltersPage = () => {

  const { cityTowns, countries, populationSizes, deleteCityTowns } = useSampleData();
  const [deleting, setDeleting] = useState(false);

  const { showSuccess, showError } = useFeedback();

  const handleDelete = async (cityTownsToDelete: CityTownDto[]) => {
    try {
      // In the api call, uncomment the exception in there to test errors coming from the api
      setDeleting(true);

      await callMimicApi();
      await deleteCityTowns(cityTownsToDelete);

      setDeleting(false);
      showSuccess('The countries were deleted');
    } catch (ex) {
      showError(`An error occured: ${ex}`);
    }
  }

  const countryOptions: OptionProps[] = countries.map(c => ({
    value: c.code,
    description: c.description
  }));

  const populationSizeOptions: OptionProps[] = populationSizes.map(c => ({
    value: c.code,
    description: c.description
  }));

  const listItemRender = (item: CityTownDto) => <>{item.description}</>;

  return (
    <PageContainer
      heading='List Samples - Filters'
      icon={<ListIcon />}
      pageInfo={<ListAndDetailSamplesFiltersPageInfo />}
      wrapRightElementForMobile={false}
    >
      <ListAndDetail
        items={cityTowns}
        keyValue={(item) => item.code}
        itemRender={listItemRender}
        searchFields={['code', 'description']}
        listUrl={listAndDetailSamplesRoutes.filters}
        newUrl={listAndDetailSamplesRoutes.new}
        editUrl={listAndDetailSamplesRoutes.edit}
        deleteOptions={{
          onDelete: handleDelete,
          busyDeleting: deleting
        }}
        //////////////////////////////////////////////////////////////////////////////
        // Add filtering to the list here.        
        //////////////////////////////////////////////////////////////////////////////
        filters={
          [{
            description: "Country", filterItems: countryOptions,
            filter: (item, filterValue) => item.countryCode === filterValue
          },
          {
            description: "Population Size", filterItems: populationSizeOptions,
            filter: (item, filterValue) => item.populationSizeCode === filterValue
          }]}
      />
    </PageContainer>
  )
}
